module.exports = __webpack_public_path__ + "static/media/xuanzhong.f879f116.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/xuanzhong.png
// module id = 693
// module chunks = 0 1